import { memo as Memo, useRef, useCallback } from 'react';

//* Components
import { Input } from 'antd';

const FormInput = Memo(({ placeholder, ...props }) => {
	//! Refs
	const ref = useRef();

	//! On Wheel
	const onWheel = useCallback((e) => e.preventDefault(), []);

	//! On Focus
	const onFocus = useCallback(() => {
		if (ref.current?.props?.type === 'number') {
			ref.current.input.addEventListener('wheel', onWheel);
		}
	}, [ref, onWheel]);

	//! On Blur
	const onBlur = useCallback(() => {
		if (ref.current?.props?.type === 'number') {
			ref.current.input.removeEventListener('wheel', onWheel);
		}
	}, [ref, onWheel]);

	return (
		<Input
			ref={ref}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholder={placeholder}
			step={props.step && '0.1'}
			addonBefore={props.addonBefore}
			{...props}
		/>
	);
});

export default FormInput;
